import {FC, ReactNode} from "react"

import {ModalLayout} from "components/modal/base"
import {Button} from "components/button"
import {ModalProps} from "lib/hooks/useModal"

interface Props extends ModalProps {
  title: string
  children: ReactNode
}

const DescriptionModal: FC<Props> = ({title, isOpened, close, children}) => (
  <ModalLayout isOpened={isOpened} close={close} lockScroll big>
    <div
      className="min-h-full pt-16 tablet:overflow-y-scroll  px-5 tablet:px-10 pb-5 tablet-big:pb-12 tablet-big:px-32 tablet:max-h-description-modal flex flex-col items-stretch"
    >
      <h1 className="pb-6">{title}</h1>
      {children}
      <div className="grow" />
      <Button onClick={close} className="mt-20 self-center">
        Got it
      </Button>
    </div>
  </ModalLayout>
)

export default DescriptionModal
